// extracted by mini-css-extract-plugin
export default {"defaultConsole":"light_defaultConsole__OMrxc","console":"light_console__2ZN46"};